import { Checkbox } from "antd";
import { ReactNode, useState } from "react";
import { useSelector } from "react-redux";

type Props = { title: string; id: Number; icon: any };

const Box = ({ id, title, icon }: Props) => {
  const { service_id } = useSelector((state: any) => state?.SalonProfile.step2);
  const equal = (e: any) => e === id;
  const che = service_id?.some(equal);
  const [isChecked, setIsChecked] = useState(che || false);
  const labelClass = isChecked ? "custom-checkbox checked" : "custom-checkbox";
  const handleCheckboxChange = (e: any) => {
    setIsChecked(e.target.checked);
  };
  console.log(id, title, icon);

  return (
    <label
      className={`${labelClass} transition-all flex !justify-start items-start gap-x-2 max-md:py-2 max-md:px-3`}
    >
      <Checkbox className="hidden" value={id} onChange={handleCheckboxChange} />
      {icon?.media_url &&
      <span
        className={`p-1 flex items-center w-12 h-12 mx-1 justify-center bg-white rounded-full`}
      >
        <img
        src={icon?.media_url}
        alt=""
        className="w-[50px] h-[40px] object-contain"
        />
      </span>
      }
      <span className="text-color-gray max-md:text-base font-medium h-fit">
        {title}
      </span>
    </label>
  );
};

export default Box;
